// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2I3fb","title":"ClientReferral_title__cosn1","itemText":"ClientReferral_itemText__1-rxG"};